export const isArray = arr => {
  return Object.prototype.toString.call(arr) === '[object Array]';
};

export const isObject = obj => {
  return Object.prototype.toString.call(obj) === '[object Object]';
};
